module.exports = __webpack_public_path__ + "img/furniture-1-7.32051305.jpg";